import { render, staticRenderFns } from "./IntelligencePatientFrictionTable.vue?vue&type=template&id=00ef6d56&scoped=true"
import script from "./IntelligencePatientFrictionTable.vue?vue&type=script&lang=js"
export * from "./IntelligencePatientFrictionTable.vue?vue&type=script&lang=js"
import style0 from "./IntelligencePatientFrictionTable.vue?vue&type=style&index=0&id=00ef6d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef6d56",
  null
  
)

export default component.exports